// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "" + {"16":"a758ecd1df232a0e925f","945":"a745b19db4c58f25ac1c"}[chunkId] + ".js";
};